var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrundrissUnten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1970,
    height: 2580,
    viewBox: "0 0 1970 2580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.603 1685.26C174.974 1685.26 184.192 1676.07 184.192 1664.73C184.192 1653.38 174.974 1644.19 163.603 1644.19C152.231 1644.19 143.013 1653.38 143.013 1664.73C143.013 1676.07 152.231 1685.26 163.603 1685.26Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.603 1633.01C174.974 1633.01 184.192 1623.82 184.192 1612.48C184.192 1601.14 174.974 1591.94 163.603 1591.94C152.231 1591.94 143.013 1601.14 143.013 1612.48C143.013 1623.82 152.231 1633.01 163.603 1633.01Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.163 1562.3C175.535 1562.3 184.752 1553.11 184.752 1541.76C184.752 1530.42 175.535 1521.23 164.163 1521.23C152.792 1521.23 143.574 1530.42 143.574 1541.76C143.574 1553.11 152.792 1562.3 164.163 1562.3Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.603 1507.41C174.974 1507.41 184.192 1498.22 184.192 1486.88C184.192 1475.54 174.974 1466.34 163.603 1466.34C152.231 1466.34 143.013 1475.54 143.013 1486.88C143.013 1498.22 152.231 1507.41 163.603 1507.41Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5996 1454.28H131.935V1569.84H84.5996V1454.28Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5996 1580.89H131.935V1696.44H84.5996V1580.89Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.935 1379.93V1436.54H74.0155V1696.35V1575.39V1724.41H24.1713V1379.93H131.935Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.865 1700.87H74.5644V1724.57H24.1713V1380.09H131.935V1403.8H39.865V1700.87Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.952 1685.26C365.323 1685.26 374.541 1676.06 374.541 1664.73C374.541 1653.39 365.323 1644.19 353.952 1644.19C342.58 1644.19 333.363 1653.39 333.363 1664.73C333.363 1676.06 342.58 1685.26 353.952 1685.26Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.952 1633.01C365.323 1633.01 374.541 1623.82 374.541 1612.48C374.541 1601.14 365.323 1591.94 353.952 1591.94C342.58 1591.94 333.363 1601.14 333.363 1612.48C333.363 1623.82 342.58 1633.01 353.952 1633.01Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.952 1562.68C365.323 1562.68 374.541 1553.48 374.541 1542.14C374.541 1530.8 365.323 1521.61 353.952 1521.61C342.58 1521.61 333.363 1530.8 333.363 1542.14C333.363 1553.48 342.58 1562.68 353.952 1562.68Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.952 1499.38C365.323 1499.38 374.541 1490.18 374.541 1478.84C374.541 1467.5 365.323 1458.3 353.952 1458.3C342.58 1458.3 333.363 1467.5 333.363 1478.84C333.363 1490.18 342.58 1499.38 353.952 1499.38Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.141 1567.15C451.47 1566.46 450.658 1565.91 449.756 1565.54C448.856 1565.16 447.884 1564.98 446.904 1564.98C445.393 1564.98 444.009 1565.44 442.789 1566.33C442.156 1566.8 441.596 1567.36 441.127 1567.98C440.636 1567.33 440.079 1566.78 439.464 1566.33C438.287 1565.45 436.839 1564.98 435.349 1564.98C434.369 1564.98 433.397 1565.16 432.497 1565.54C431.595 1565.91 430.783 1566.46 430.112 1567.15C428.77 1568.53 428.034 1570.41 428.034 1572.45C428.034 1574.55 428.859 1576.47 430.631 1578.5C432.215 1580.32 434.494 1582.16 437.132 1584.29C438.032 1585.02 439.055 1585.85 440.114 1586.73C440.395 1586.96 440.754 1587.09 441.127 1587.09C441.498 1587.09 441.857 1586.96 442.138 1586.73C443.199 1585.85 444.22 1585.02 445.122 1584.29C447.76 1582.16 450.038 1580.32 451.622 1578.5C453.395 1576.47 454.219 1574.55 454.219 1572.45C454.219 1570.41 453.483 1568.53 452.141 1567.15Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.727 1380.1H414.804V1718.72H384.727V1380.1ZM421.487 1557.96H458.248V1595.58H421.487V1557.96Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.698 1376.08H463.284V1722.74H380.698V1376.08Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.843 1375.77H566.612V1457.92H462.843V1375.77Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.75 2440.75C1290.54 2448.64 1333.26 2418.8 1341.16 2374.11C1349.05 2329.45 1319.15 2286.83 1274.35 2278.96C1229.56 2271.07 1186.85 2300.91 1178.95 2345.59C1171.05 2390.26 1200.96 2432.88 1245.75 2440.75Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.17 2335.61C1124.54 2322.2 1137.64 2311.64 1151.08 2314L1175.13 2319.9L1166.54 2368.43L1141.93 2365.77C1128.49 2363.4 1119.8 2349.01 1122.17 2335.61Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.37 2439.94C1137.54 2428.81 1139.31 2412.1 1150.49 2404.28L1171.67 2391.5L1200.02 2431.86L1180.72 2447.35C1169.54 2455.16 1153.19 2451.1 1145.37 2439.94Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.08 2468.55C1211.71 2481.95 1222.3 2495.01 1235.74 2497.38C1249.18 2499.75 1263.61 2491.07 1265.98 2477.67L1268.65 2453.12L1219.99 2444.56L1214.08 2468.55Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.6 2469.14C1312.42 2480.28 1329.18 2482.05 1340.36 2474.25C1351.53 2466.44 1355.6 2450.13 1347.77 2438.98L1332.25 2419.74L1291.77 2448.01L1304.6 2469.14Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.18 2353.94C1391.61 2356.31 1400.3 2370.7 1397.93 2384.1C1395.56 2397.51 1382.46 2408.07 1369.02 2405.71L1344.98 2399.81L1353.56 2351.28L1378.18 2353.94Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.74 2279.76C1366.91 2268.61 1350.56 2264.55 1339.38 2272.35L1320.09 2287.85L1348.43 2328.21L1369.62 2315.43C1380.79 2307.61 1382.56 2290.9 1374.74 2279.76Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.36 2222.33C1270.93 2219.96 1256.49 2228.64 1254.12 2242.04L1251.45 2266.59L1300.11 2275.15L1306.03 2251.16C1308.4 2237.76 1297.8 2224.7 1284.36 2222.33Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.75 2245.46C1168.57 2253.26 1164.51 2269.58 1172.33 2280.73L1187.85 2299.97L1228.33 2271.7L1215.51 2250.57C1207.68 2239.43 1190.93 2237.66 1179.75 2245.46Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.928 2478.32H935.275V2213.03H893.928V2478.32Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.35 1473.29C1369.59 1472.49 1370.15 1471.82 1370.89 1471.43C1371.63 1471.03 1372.5 1470.95 1373.31 1471.2L1376.01 1472.02C1376.41 1472.14 1376.78 1472.33 1377.1 1472.59C1377.42 1472.86 1377.69 1473.18 1377.89 1473.55C1378.08 1473.91 1378.2 1474.31 1378.24 1474.72C1378.28 1475.14 1378.24 1475.55 1378.12 1475.95L1363.51 1523.53C1383.41 1526.91 1396.76 1533.14 1396.76 1540.27C1396.76 1544.29 1392.5 1548.03 1385.21 1551.14C1397.7 1568.02 1391.18 1593.21 1391.18 1593.21C1389.12 1601.77 1384.17 1608.09 1377.82 1612.73V1636.71L1364.64 1649.85V1685.96L1344.06 1707.32V1771.71H1337.47V1704.66L1358.06 1683.3V1647.13L1371.23 1633.98V1616.77C1357.12 1623.99 1339.18 1625.28 1330.05 1625.47V1771.71H1323.47V1625.44C1313.43 1624.94 1297.44 1622.97 1284.76 1615.97V1679.98L1301.23 1696.41V1667.73C1298.92 1667.04 1296.88 1665.64 1295.4 1663.74C1293.92 1661.83 1293.08 1659.51 1293 1657.1L1292.99 1656.7C1292.99 1654.57 1293.59 1652.48 1294.71 1650.66C1295.84 1648.85 1297.44 1647.39 1299.35 1646.44C1301.27 1645.47 1303.41 1645.07 1305.54 1645.25C1307.67 1645.43 1309.7 1646.21 1311.42 1647.49C1313.13 1648.77 1314.45 1650.49 1315.24 1652.47C1316.03 1654.45 1316.25 1656.62 1315.88 1658.71C1315.5 1660.81 1314.55 1662.77 1313.13 1664.36C1311.71 1665.95 1309.87 1667.12 1307.82 1667.73V1770.06H1301.23V1705.71L1278.17 1682.71V1611.58C1272.55 1607.06 1268.2 1601.08 1266.31 1593.21C1266.31 1593.21 1259.76 1567.88 1272.39 1551L1272.49 1550.8C1265.66 1547.77 1261.7 1544.15 1261.7 1540.27C1261.7 1529.54 1291.94 1520.85 1329.23 1520.85C1338.1 1520.85 1346.56 1521.34 1354.32 1522.23L1369.35 1473.29ZM1304.52 1651.78C1303.21 1651.78 1301.96 1652.3 1301.03 1653.22C1300.1 1654.14 1299.58 1655.39 1299.58 1656.7C1299.58 1658.02 1300.1 1659.27 1301.03 1660.19C1301.96 1661.11 1303.21 1661.63 1304.52 1661.63C1305.84 1661.63 1307.09 1661.11 1308.02 1660.19C1308.94 1659.27 1309.47 1658.02 1309.47 1656.7C1309.47 1655.39 1308.94 1654.14 1308.02 1653.22C1307.09 1652.3 1305.84 1651.78 1304.52 1651.78ZM1329.23 1524.71C1297.97 1524.71 1272.63 1531.4 1272.63 1539.66C1272.63 1547.92 1297.97 1554.62 1329.23 1554.62C1360.49 1554.62 1385.83 1547.92 1385.83 1539.66C1385.83 1534.66 1376.55 1530.24 1362.29 1527.53L1360.99 1531.77C1362.53 1533.56 1363.38 1535.84 1363.38 1538.2C1363.38 1538.61 1363.35 1539.01 1363.3 1539.41H1343.54C1343.49 1539.01 1343.46 1538.6 1343.46 1538.2C1343.46 1533.07 1347.4 1528.85 1352.44 1528.36L1353.13 1526.11C1345.87 1525.21 1337.77 1524.71 1329.23 1524.71ZM1273.23 1489.29L1260.88 1503.9L1267.38 1485.93L1248.52 1482.56L1267.38 1479.19L1260.88 1461.22L1273.23 1475.83L1285.58 1461.22L1279.08 1479.19L1297.94 1482.56L1279.08 1485.93L1285.58 1503.9L1273.23 1489.29ZM1321.68 1440.25L1317.08 1456.15L1316.28 1438.93L1301.24 1441.14L1314.18 1433.14L1303.73 1419.45L1317.47 1428.67L1322.06 1412.77L1322.86 1429.98L1337.9 1427.78L1324.96 1435.77L1335.41 1449.47L1321.68 1440.25Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.26 1495.02L1338.43 1504.81L1337.95 1494.21L1328.69 1495.57L1336.65 1490.65L1330.22 1482.22L1338.67 1487.9L1341.5 1478.11L1341.99 1488.71L1351.25 1487.35L1343.29 1492.27L1349.72 1500.7L1341.26 1495.02ZM1308.64 1540.06C1304.55 1540.06 1301.23 1543.34 1301.23 1547.38C1301.23 1547.68 1301.25 1547.98 1301.29 1548.27H1315.99C1316.03 1547.98 1316.05 1547.68 1316.05 1547.38C1316.05 1543.34 1312.73 1540.06 1308.64 1540.06ZM1322.64 1528.56C1319.91 1528.56 1317.7 1530.53 1317.7 1532.95C1317.7 1533.14 1317.72 1533.31 1317.74 1533.49H1327.54C1327.57 1533.31 1327.58 1533.14 1327.58 1532.95C1327.58 1530.53 1325.37 1528.56 1322.64 1528.56Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.702 1348V1722.01M891 1722.01H1026.96V1437.42M1026.33 1437.47H891M1017.95 1437.42V1722.01M1026.96 1425.63V1711.79M1025.32 1711.72H1158M1158 1711.79V1425.63M1158 1427.29H1025.32M955.503 1348.2H1091.86M1091.66 1348V1711.79M955.702 1732C960.678 1732 964.711 1727.9 964.711 1722.84C964.711 1717.78 960.678 1713.68 955.702 1713.68C950.727 1713.68 946.694 1717.78 946.694 1722.84C946.694 1727.9 950.727 1732 955.702 1732ZM1092.48 1709.74L1078.33 1691.01H1106.63L1092.48 1709.74Z",
    stroke: "#9FA2B7",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.195 2039.49H356.603C357.568 2088.65 397.758 2128.21 447.195 2128.21",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.621 2142.17V2232.53C741.334 2231.56 701.676 2191.48 701.676 2142.17",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.159 2142.17V2232.53C948.872 2231.56 909.214 2191.48 909.214 2142.17",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.88 2031.28H1581.22C1580.35 2075.88 1543.82 2111.78 1498.88 2111.78",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.77 1947.49H1647.11C1646.23 1902.89 1609.7 1866.99 1564.77 1866.99",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.41 1738.85H1400.07C1400.95 1694.24 1437.48 1658.35 1482.41 1658.35",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.624 1934.35H979.216C978.251 1885.2 938.061 1845.64 888.624 1845.64",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.678 1698.6V1608.24C806.965 1609.2 846.623 1649.3 846.623 1698.6",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.925 1795.2H611.333C612.298 1746.05 652.488 1706.49 701.925 1706.49",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.307 1361.81V1271.45C262.02 1272.41 222.362 1312.5 222.362 1361.81",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.12 2560.29H1798.66V2576.71H1535.12V2560.29ZM1101.93 2560.29H1396.76V2576.71H1101.93V2560.29ZM919.097 2560.29H1029.45V2576.71H919.097V2560.29ZM504.021 2560.29H861.447V2576.71H504.021V2560.29ZM69.1793 2560.29H410.134V2576.71H69.1793V2560.29Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950.2 1398.77H1966.67V1513.77H1950.2V1398.77ZM1950.2 1641.92H1966.67V1937.64H1950.2V1641.92ZM1950.2 2003.35H1966.67V2299.07H1950.2V2003.35Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.907 1331.42H831.799V1347.84H597.907V1331.42ZM915.802 1331.42H1139.81V1347.84H915.802V1331.42ZM1197.46 1331.42H1322.64V1347.84H1197.46V1331.42Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.137 1040.63H449.666V1336.34H466.137V1040.63Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.656 1973.78H82.5853V1983.64H233.656V1973.78Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.45 2557H1101.93V2580H1029.45V2557ZM846.623 2557H919.097V2580H846.623V2557ZM408.487 2557H504.021V2580H408.487V2557ZM0 2557H69.1794V2580H0V2557ZM1395.12 2557H1535.12V2580H1395.12V2557Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.37 2557H1948.55V2580H1795.37V2557Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946.9 1328.13H1969.96V1398.77H1946.9V1328.13ZM1946.9 1513.77H1969.96V1641.92H1946.9V1513.77ZM1946.9 1937.64H1969.96V2003.35H1946.9V1937.64ZM1946.9 2299.07H1969.96V2580H1946.9V2299.07Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.64 1328.13H1950.2V1351.13H1322.64V1328.13Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.98 1327.68H1210.58V1350.79H1125.98V1327.68Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.889 1327.68H915.489V1350.79H830.889V1327.68Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.119 1327.68H623.419V1350.79H581.119V1327.68Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.436 1328.13H434.841V1369.2H581.436V1328.13Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.371 996.269H469.431V1040.63H446.371V996.269Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 996.269H469.431V1019.27H0V996.269Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1015.98H23.0598V2563.57H0V1015.98Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4128 1912.99H74.1209V2064.14H21.4128V1912.99Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.843 2126.57H446.372V2570.14H462.843V2126.57Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.843 1991.85H446.372V2041.14H462.843V1991.85Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.35 2110.42H1054.47V2563.58H1037.35V2110.42Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.3 1770.06H1564.77V1868.64H1548.3V1770.06ZM1548.3 1945.85H1564.77V1986.92H1548.3V1945.85Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.41 2110.14H1498.89V2570.14H1482.41V2110.14ZM1482.41 1995.14H1498.89V2032.92H1482.41V1995.14Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.89 1737.21H1482.41V1776.63H1498.89V1737.21Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.41 1328.13H1498.89V1658.35H1482.41V1328.13Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 1328.13H1182.64V1995.14H1159.58V1328.13Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.303 2128.5H873.189V2563.58H889.303V2128.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.448 1932.71H866.388V1975.42H889.448V1932.71Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.448 1328.13H866.388V1847.28H889.448V1328.13Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.94 1327.68H713.054V1708.73H696.94V1327.68ZM696.94 1791.29H713.054V1823.04H696.94V1791.29Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.206 1822.63H676.969V1858.78H713.206V1822.63Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.965 1360.99H581.436V1837.42H564.965V1360.99Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0717 1970.75H97.212V1986.83H10.0717V1970.75ZM219.854 1970.75H436.091V1986.83H219.854V1970.75Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.726 1960.64H436.489V1996.78H472.726V1960.64Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.974 2126.57H910.861V2143H788.974V2126.57ZM996.512 2126.57H1050.87V2143H996.512V2126.57ZM446.372 2126.57H703.323V2143H446.372V2126.57Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.16 2137.25H1205.7H1054.16ZM1081.71 2134.53H1233.24H1081.71ZM1301.22 2134.53H1452.76H1301.22ZM1330.88 2137.25H1482.41H1330.88Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.16 2137.25H1205.7M1081.71 2134.53H1233.24M1301.22 2134.53H1452.76M1330.88 2137.25H1482.41",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.77 1960.64H1472.53V1996.78H1508.77V1960.64Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1966.94 1970.75H1508.69V1986.83H1966.94V1970.75Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.83 1770.06H1180.99V1786.49H1559.83V1770.06Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.46 1972.14H856.506V1995.14H1169.46V1972.14Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.325 1697.78H711.559V1705.99H759.325V1697.78Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.918 1697.78H844.976V1705.99H877.918V1697.78Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.617 1822.63H378.84V1839.06H678.617V1822.63Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.553 1360.99H309.66V1377.42H571.553V1360.99Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.009 1360.99H9.88293V1377.42H224.009V1360.99Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.37 0H1970V1331.41H1336.37V0Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1169.2 0H1336.37V1128.96H1169.2V0Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.861 1024.7V1141.98H119.093V1024.7H193.861ZM111.505 1062.48V1104.2H69.6793V1062.48H111.505Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.218 1141.98H201.45V1024.7H276.218V1141.98ZM325.631 1104.2H283.806V1062.48H325.631V1104.2Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.861 1146.27V1263.56H119.093V1146.27H193.861ZM111.505 1184.06V1225.77H69.6793V1184.06H111.505Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.218 1263.56H201.45V1146.27H276.218V1263.56ZM325.631 1225.77H283.806V1184.06H325.631V1225.77Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.41 1425.95V1480.87H1604.87V1425.95H1755.41ZM1701.05 1389.47V1420.08H1659.23V1389.47H1701.05Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.17 1425.95V1480.87H1760.63V1425.95H1911.17ZM1856.81 1389.47V1420.08H1814.99V1389.47H1856.81Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.87 1541.86V1486.94H1755.41V1541.86H1604.87ZM1659.23 1578.34V1547.73H1701.05V1578.34H1659.23Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.98 1541.86H1911.51V1486.94H1760.98V1541.86ZM1815.33 1578.34H1857.16V1547.73H1815.33V1578.34Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.44 1755.52V1810.45H1750.91V1755.52H1901.44ZM1847.09 1719.05V1749.66H1805.26V1719.05H1847.09Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.91 1816.31H1901.44V1871.24H1750.91V1816.31ZM1805.26 1877.1H1847.09V1907.71H1805.26V1877.1Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.682 2125.5V2242.79H146.914V2125.5H221.682ZM139.325 2163.29V2205H97.5V2163.29H139.325Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.367 2250.76V2368.04H146.599V2250.76H221.367ZM139.011 2288.54V2330.26H97.1853V2288.54H139.011Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.218 2367.57H229.451V2250.28H304.218V2367.57ZM353.632 2329.78H311.807V2288.07H353.632V2329.78Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.367 2372.34V2489.62H146.599V2372.34H221.367ZM139.011 2410.12V2451.84H97.1853V2410.12H139.011Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.888 2489.62H229.12V2372.34H303.888V2489.62ZM353.302 2451.84H311.477V2410.12H353.302V2451.84Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.29 2362.18H475V2287.41H592.29V2362.18ZM554.5 2279.82H512.79V2238H554.5V2279.82Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 2443.77V2369H864.29V2443.77H747ZM784.79 2493.18V2451.36H826.5V2493.18H784.79Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 2368H592.29V2442.77H475V2368ZM512.79 2450.36H554.5V2492.18H512.79V2450.36Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.29 2288.41V2363.18H747V2288.41H864.29ZM826.5 2239V2280.83H784.79V2239H826.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724.07 2111.92V2249.35H1650.49V2111.92H1724.07ZM1643 2161.58V2199.7H1601.85V2161.58H1643Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.72 2249.35V2111.92H1805.3V2249.35H1731.72ZM1812.78 2199.7V2161.58H1853.94V2199.7H1812.78Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724.27 2255.44V2392.87H1650.69V2255.44H1724.27ZM1643.21 2305.1V2343.22H1602.05V2305.1H1643.21Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.34 2392.87H1731.76V2255.44H1805.34V2392.87ZM1853.98 2343.22H1812.83V2305.1H1853.98V2343.22Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724.27 2398.39V2535.82H1650.69V2398.39H1724.27ZM1643.21 2448.04V2486.17H1602.05V2448.04H1643.21Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.34 2535.82H1731.76V2398.39H1805.34V2535.82ZM1853.98 2486.17H1812.83V2448.04H1853.98V2486.17Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.268 2243.79H229.5V2126.5H304.268V2243.79ZM353.682 2206H311.856V2164.29H353.682V2206Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1970,
    height: 2580,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrundrissUnten);
export default __webpack_public_path__ + "static/media/grundriss-unten.1d0b36da416e4c2e77aeac74a238ec3f.svg";
export { ForwardRef as ReactComponent };